import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"
import { AppFormSection, AppNote } from "@components"
import { promptHelp } from "./@services/profile"
import { Helper } from "./fields"


const pillSx = (tone) => ({
	display: 'inline-flex', alignItems: 'center', gap: 0.6, px: 1, py: 0.35, borderRadius: '999px', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
	...(tone === 'info'
		? { backgroundColor: dsColorNew.noteInfoBg, color: dsColorNew.noteInfo, border: `1px solid ${dsColorNew.noteInfoBorder}` }
		: { backgroundColor: dsColorNew.pillTrackBg, color: dsColorNew.textMuted, border: `1px solid ${dsColorNew.grayBorder}` }),
})

/**
 * "What Iris is told": the server's text, the saved version — never a copy of its template here (UX
 * D10). While the draft is dirty, the amber note says it is not the draft (criterion 10).
 */
export default function PromptSection({ prompt, saved, dirty }) {
	const { help, dirtyWarning } = promptHelp({ prompt, saved, dirty })

	return <AppFormSection
		icon="comment-dots"
		title="What Iris is told"
		hint="Generated when you save; office, site and compset ids travel with the names, which is what lets her filter instead of guess."
		action={<>
			<Box component="span" sx={pillSx('info')} title="DSB.setContext({ profile }) — widget 0.109.4"><IconSeeker icon="paper-plane" sx={{ fontSize: 10 }}/>sent to Iris with every question</Box>
			<Box component="span" sx={pillSx('neutral')}><IconSeeker icon="lock" sx={{ fontSize: 10 }}/>read-only</Box>
		</>}
	>
		{!!dirtyWarning && <AppNote severity="warning" sx={{ mb: 1.5 }}>{dirtyWarning}</AppNote>}
		{!!prompt && <Typography component="pre" sx={{
			m: 0, p: 1.75, maxHeight: 260, overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
			fontFamily: 'Roboto Mono, monospace', fontSize: 12, lineHeight: 1.6, color: dsColorNew.textDark,
			backgroundColor: dsColorNew.filterInputBg, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '10px',
		}}>{prompt}</Typography>}
		{!!help && <Helper sx={{ mt: prompt ? 1 : 0 }}>{help}</Helper>}
	</AppFormSection>
}
